export enum InfoPopupTypes {
	RESTORE = 0,
	NO_MONEY,
	WIN_LIMIT,
	LOSS_LIMIT,
	MESSAGE,
	RELAX_MESSAGE,
	RELAX_REALITY_CHECK,
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/popupmenus/info/InfoPopupTypes.ts